import { createFileRoute } from '@tanstack/react-router'
import AdminReminderSettingsPage from '@/spa/pages/admin/AdminReminderSettingsPage'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/admin/reminder-settings')({
  component: AdminReminderSettingsPage,
  errorComponent: routeErrorComponent,
})
